module.exports = __webpack_public_path__ + "static/media/peter.c356651f.jpeg";